module.exports = __webpack_public_path__ + "img/lucky.7e8cbb3d.svg";